import { Star, Megaphone, Globe } from "lucide-react";

export const updatesData = [
  {
    id: 1,
    title: "Favorites Feature",
    description: "Save and revisit your favorite resources for quick access.",
    icon: Star,
  },
  {
    id: 2,
    title: "Emergency Alerts",
    description: "Receive real-time notifications for urgent updates in your area.",
    icon: Megaphone,
  },
  {
    id: 3,
    title: "Join the Movement",
    description: "Be part of a global network dedicated to animal welfare.",
    icon: Globe,
  },
];
